@if (leftnav.myAccount$|async; as navNodes) {
<div class="titleBar d-none d-sm-block">{{ 'common.text_account_yourAccount' | cxTranslate }}</div>
<div class="py-3 topmargin">
  <ul>
    @for (nav of navNodes.navNodes; track nav; let i = $index) {
    @if (!nav.childNodes) {
    <li (click)="hideOnMobile()" class="normal-node-list " [ngClass]="isMobile ? 'col-12' : ''">
      <a [ngClass]="isMobile ? 'col-10 p-0' : ''"
        [class.StateOpenColor]="(nav.nodeId == navState) || (nav.nodeId == mobNavState)" [routerLink]="nav.nodeLink"
        routerLinkActive="active">{{ nav.nodeName
        }} </a>
      <img style="width: 20px"
        [src]="((nav.nodeId == navState) &&(hideActiveState)) || (nav.nodeId == mobNavState) ? '/icons/link-right-blue.svg' : ''"
        alt="" />
    </li>
    }
    @if (nav.childNodes && hasVisibleChildren(nav)) {
    <mat-accordion [multi]="false">
      <mat-expansion-panel [expanded]="(nav.nodeId == navState) || (nav.nodeId == mobNavState)"
        (opened)="(panelOpenState[i] = true)" (closed)="panelOpenState[i] = false">
        <mat-expansion-panel-header>
          <mat-panel-title [ngClass]="isMobile? 'col-10':''">
            <a class="header-title" [routerLink]="nav.nodeLink">{{ nav.nodeName }}</a>
          </mat-panel-title>
          <mat-panel-description>
            <img [src]="'/icons/arrow_down_blue.svg'" alt="" />
          </mat-panel-description>
        </mat-expansion-panel-header>
        @for (childNav of nav.childNodes; track childNav) {
        <ul>
          @if (displayChildNavOrNot(childNav)) {
          <li (click)="hideOnMobile()" class="child-node-list " [ngClass]="isMobile ? 'col-12' : ''">
            @if (childNav.nodeLink === '/submit-warranty') {
            <a [ngClass]="isMobile ? 'col-10' : ''" [class.StateOpenColor]="childNav.nodeId == childNavState"
              [routerLink]="childNav?.nodeLink">
              {{ childNav.nodeName }}
            </a>
            }
            @if (childNav.nodeLink !== '/submit-warranty') {
            <a [ngClass]="isMobile ? 'col-10' : ''"
              [class.StateOpenColor]="(childNav.nodeId == childNavState)||(childNav.nodeId == mobChildNavState)"
              [routerLink]="childNav.nodeLink">
              {{ childNav.nodeName}}
            </a>
            }
            <img style="width: 20px"
              [src]="(childNav.nodeId == childNavState)||(childNav.nodeId == mobChildNavState) ? '/icons/link-right-blue.svg' : ''"
              alt="" />
          </li>
          }
        </ul>
        }
      </mat-expansion-panel>
    </mat-accordion>
    }
    }
  </ul>
</div>
@if (navNodes.companyAccountNavNodes.length) {
<div class="titleBar company-account-title">{{ 'common.text_company_breadcrumb' | cxTranslate }}</div>
<div class="py-3 topmargin company-account-section">
  <ul>
    @for (nav of navNodes.companyAccountNavNodes; track nav; let i = $index) {
    @if (!nav.childNodes && hasVisibleCompanyChildren(nav)) {
    <li (click)="hideOnMobile()" class="normal-node-list " [ngClass]="isMobile ? 'col-12' : ''">
      <a [ngClass]="isMobile ? 'col-10' : ''" [class.StateOpenColor]="nav.nodeId == navState"
        [routerLink]="nav.nodeLink" routerLinkActive="active">{{ nav.nodeName
        }} </a>
      <img style="width: 20px" [src]="nav.nodeId == navState ? '/icons/link-right-blue.svg' : ''" alt="" />
    </li>
    }
    @if (nav.childNodes && hasVisibleChildren(nav)) {
    <mat-accordion [multi]="false">
      <mat-expansion-panel [expanded]="(nav.nodeId == navState)" (opened)="(panelOpenStateMyCompany[i] = true)"
        (closed)="panelOpenStateMyCompany[i] = false">
        <mat-expansion-panel-header>
          <mat-panel-title [ngClass]="isMobile? 'col-10':''">
            <a class="header-title" (click)="hideOnMobile()" [routerLink]="nav.nodeLink">{{
              nav.nodeName }}</a>
          </mat-panel-title>
          <mat-panel-description>
            <img [src]="'/icons/arrow_down_blue.svg'" alt="" />
          </mat-panel-description>
        </mat-expansion-panel-header>
        @for (childNav of nav.childNodes; track childNav) {
        <ul>
          <li (click)="hideOnMobile()" class="child-node-list " [ngClass]="isMobile ? 'col-12' : ''">
            <a [ngClass]="isMobile ? 'col-10' : ''" [class.StateOpenColor]="childNav.nodeId == childNavState"
              [routerLink]="childNav.nodeLink">{{ childNav.nodeName }}</a>
            <img style="width: 20px" [src]="childNav.nodeId == childNavState ? '/icons/link-right-blue.svg' : ''"
              alt="" />
          </li>
        </ul>
        }
      </mat-expansion-panel>
    </mat-accordion>
    }
    }
  </ul>
</div>
}
}